exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-input[data-v-30849f45] {\n  padding: 0.25rem 0 0;\n}\n.list-input-value[data-v-30849f45] {\n  width: 100%;\n}", ""]);

// exports
